export const PROJECTS_REDUCER_KEYS = {
  PROJECTS: 'projects',
  BY_ID: 'byId',
  MODIFIED: 'modified',
  UNSYNCED: 'unsynced',
  ACCESS_DENIED: 'accessDenied',
  CENTER_BY_ID: 'centerByID',
}
